module.exports = __webpack_public_path__ + "img/img_redirect@3x.a0beae2c.png";